import React from 'react';

// Reuse the live 526 components so v1 and v2 stay in sync.
import { isScreenerBdd } from '../../utils/bdd';
import { ConfirmationVeteranInfo } from '../../../shared/components/ConfirmationVeteranInfo';
import VeteranInformationCard from '../../../shared/components/VeteranInformationCard';

// Section I Items 1/2/3 — identity is prefilled from the authenticated profile
// (name, DOB, gender). Displayed read-only, mirroring the live 526 flow; this
// page collects no editable data.
// Persists the screener's BDD result in form data so it survives session
// storage being wiped (e.g. the browser is closed before dates are entered).
export const onNavForward = ({ formData, setFormData, goNextPath }) => {
  if (!formData?.['view:isBddData'] && isScreenerBdd()) {
    setFormData({ ...formData, 'view:isBddData': true });
  }
  goNextPath();
};

export default {
  onNavForward,
  uiSchema: {
    'ui:title': <h3 className="vads-u-margin-y--0">Your information</h3>,
    'ui:description': <VeteranInformationCard />,
    'ui:options': {
      forceDivWrapper: true,
      showFieldLabel: false,
    },
    'ui:confirmationField': ConfirmationVeteranInfo,
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
